export default "__VITE_PUBLIC_ASSET__2c242ca4__"